import { render, staticRenderFns } from "./LocalePickerForm.vue?vue&type=template&id=6eea5de2&scoped=true&lang=html&"
import script from "./LocalePickerForm.vue?vue&type=script&lang=js&"
export * from "./LocalePickerForm.vue?vue&type=script&lang=js&"
import style0 from "./LocalePickerForm.vue?vue&type=style&index=0&id=6eea5de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eea5de2",
  null
  
)

export default component.exports